export default "__VITE_ASSET__01a752bd__"